import { render } from "./sfPanel.vue?vue&type=template&id=6ca95ad8&scoped=true"
import script from "./sfPanel.vue?vue&type=script&lang=js"
export * from "./sfPanel.vue?vue&type=script&lang=js"

import "./sfPanel.vue?vue&type=style&index=0&id=6ca95ad8&scoped=true&lang=css"
import "./sfPanel.vue?vue&type=style&index=1&id=6ca95ad8&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca95ad8"]])

export default __exports__